import { render, staticRenderFns } from "./CartProductCard.vue?vue&type=template&id=2ec0ca58&scoped=true&"
import script from "./CartProductCard.vue?vue&type=script&lang=js&"
export * from "./CartProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CartProductCard.vue?vue&type=style&index=0&id=2ec0ca58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0ca58",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiNumberInput: require('/app/components/UI/UiNumberInput.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
